import { MuiTelInput } from 'mui-tel-input'

type props = {
  label: string;
  required?: boolean;
  value: string;
  error: boolean | undefined;
  helperText: string | undefined;
  handleChange: (value: string) => void;
}

export default function PhoneNumberInput({ required = false, label, value, handleChange, error, helperText }: props) {
  return (
    <MuiTelInput
      label={label}
      error={error}
      required={required}
      helperText={helperText}
      value={value}
      defaultCountry="IR"
      onChange={handleChange}
      fullWidth
      sx={{

        marginBottom: "1rem",
        "& .MuiOutlinedInput-root": {
          fontFamily: "'Yekan !important'"
        },
        "& label": {
          left: "unset",
          right: "1.8rem",
          transformOrigin: "right",
          fontFamily: "'Yekan !important'",
          fontSize: "1.2rem",
        },
        "& legend": {
          fontFamily: "'Yekan !important'",
          textAlign: "right",
          fontSize: "1.2rem"
        },
        '& .MuiFormLabel-asterisk': {
          color: "red"
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#a0a0a0",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgb(201, 126, 245)",
        },
        "& fieldset": {
          borderRadius: "15px",
        },
      }}
    />

  )
}
